import React, { useState, useEffect, useCallback } from "react";
import Spinner from "./BePatient";
import { useNavigate, Link } from "react-router-dom";
import LoggedNav from "../components/LoggedNav";
import ContactUsPop from "../components/ContactUsPop";
import OrderItemChef from "../components/OrderItemChef";
import Pagination from "../components/Pagination";
import { isMobile } from 'react-device-detect';
import { apiCall, getJsonResponse } from '../utils/apiUtils';

const LIMIT = 12;

function OrderListChef(props) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [search] = useState("");
  const navigate = useNavigate();

  const routeTosignIn = () => {
    if (!localStorage.getItem("role")) {
      navigate("/sign-in");
    }
  };

  const fetchOrders = useCallback(async (page, searchQuery) => {
    const isInitial = page === 1 && !searchQuery;
    isInitial ? setLoading(true) : setListLoading(true);

    try {
      const offset = (page - 1) * LIMIT;
      const response = await apiCall(
        `${process.env.REACT_APP_BASE_URL}book/chef_booking_history`,
        {
          method: "POST",
          body: JSON.stringify({
            user_id: parseInt(localStorage.getItem("chef_id")),
            offset,
            limit: LIMIT,
            search: searchQuery || "",
            filters: {
              project_id: [],
              location: [],
              configuration: [],
              budget_from: [],
              budget_to: [],
            },
          }),
        }
      );

      const parsedData = await response.json();
      //console.log(parsedData);
      setOrders(parsedData.data || []);
      setTotalItems(parsedData.total ?? parsedData.count ?? parsedData.data?.length ?? 0);
    } catch (error) {
      //console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
      setListLoading(false);
    }
  }, []);

  const getStatusList = async () => {
    try {
      const response = await apiCall(`${process.env.REACT_APP_BASE_URL}status/all_status`);
      const parsedData = await getJsonResponse(response);
      parsedData.data.forEach((element) => {
        localStorage.setItem(element.name, element.color);
      });
    } catch (error) {
      //console.error("Error fetching status list:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchOrders(page, search);
  };

  useEffect(() => {
    const title = `Order History | CHEF | CHEF REPUBLIC`;
    const desc = "Review Orders you have Meal Prepped for customers of Chef Republic";
    document.title = title;
    document.querySelector("meta[name='title']").setAttribute("content", title);
    document.querySelector("meta[name='description']").setAttribute("content", desc);
    document.querySelector("meta[property='og:title']").setAttribute("content", title);
    document.querySelector("meta[property='og:description']").setAttribute("content", desc);
    document.querySelector("meta[property='twitter:title']").setAttribute("content", title);
    document.querySelector("meta[property='twitter:description']").setAttribute("content", desc);

    localStorage.removeItem("from_msg");
    routeTosignIn();
    getStatusList();
    fetchOrders(1, "");
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <LoggedNav customer={props.customer} main={true} />
          <div className="container my-5">
            <div className="text-center mb-4">
              <h1 className="fw-bold text-center fs-2">Order History</h1>
              <div className="text-center mt-3">
                <Link
                  className="order_details mx-2"
                  to="/chef/order-list"
                  style={{
                    width: isMobile ? "165px" : "200px",
                    display: "inline-block",
                    textAlign: "center",
                  }}
                >
                  Order
                </Link>
                <Link
                  className="btn-white mx-2"
                  to="/subscription-list"
                  style={{
                    width: isMobile ? "165px" : "200px",
                    display: "inline-block",
                    textAlign: "center",
                  }}
                >
                  Subscription
                </Link>
              </div>
            </div>

            {/* Order list */}
            <div className="row py-4" style={{ opacity: listLoading ? 0.5 : 1, transition: "opacity 0.2s" }}>
              {listLoading && (
                <div className="text-center w-100 mb-3">
                  <div className="spinner-border spinner-border-sm text-secondary" role="status" />
                </div>
              )}
              {orders && orders.length > 0 ? (
                orders.map((content, index) => (
                  <OrderItemChef key={index} data={content} />
                ))
              ) : (
                <h4 className="py-3 text-center fs-6">You have No Orders yet. Stay Tuned</h4>
              )}
            </div>

            {/* Pagination */}
            <Pagination
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={LIMIT}
              onPageChange={handlePageChange}
              loading={listLoading}
            />
          </div>
          <ContactUsPop />
        </>
      )}
    </>
  );
}

export default OrderListChef;
